import { SvgIcon } from '../../icons/SvgIcon';
import * as React from 'react';

interface IProps {
	className?: string;
}

export const ComputerCoffeeGraphic: React.FC<IProps> = props => {
	const { className } = props;
	return (
		<SvgIcon className={`computer-coffee-graphic ${className || ''}`} height={180} width={180}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M90 180c49.706 0 90-40.294 90-90S139.706 0 90 0 0 40.294 0 90s40.294 90 90 90z'
				fill='#E8F3F9'
			/>
			<path d='M37 50h106a3 3 0 013 3v75H34V53a3 3 0 013-3z' fill='#fff' stroke='#00AAE8' strokeWidth='2' />
			<path d='M37 50h106a3 3 0 013 3v8H34v-8a3 3 0 013-3z' fill='#E8F3F9' stroke='#00AAE8' strokeWidth='2' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M39.5 57a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm5 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm5 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z'
				fill='#00AAE8'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M52 81a6 6 0 100-12 6 6 0 000 12zm0 18a6 6 0 100-12 6 6 0 000 12zm0 18a6 6 0 100-12 6 6 0 000 12z'
				fill='#E8F3F9'
			/>
			<rect x='62' y='71' width='28' height='3' rx='1.5' fill='#E8F3F9' />
			<rect x='62' y='77' width='15' height='3' rx='1.5' fill='#E8F3F9' />
			<rect x='62' y='89' width='26' height='3' rx='1.5' fill='#E8F3F9' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M62 108.5a1.5 1.5 0 011.5-1.5h29a1.5 1.5 0 010 3h-29a1.5 1.5 0 01-1.5-1.5z'
				fill='#E8F3F9'
			/>
			<rect x='62' y='95' width='35' height='3' rx='1.5' fill='#E8F3F9' />
			<rect x='62' y='113' width='20' height='3' rx='1.5' fill='#E8F3F9' />
			<path stroke='#00AAE8' d='M28.5 127.5h29v1h-29zm91 12h29v1h-29z' />
			<path
				d='M116 100h36v25c0 8.284-6.716 15-15 15h-6c-8.284 0-15-6.716-15-15v-25z'
				fill='#CAE0EC'
				stroke='#00AAE8'
				strokeWidth='2'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M164.184 108H152v5h7.788c.117 0 .212.095.212.212v.726a9.132 9.132 0 01-8 9.062v5c7.18 0 13-5.82 13-13v-6.184a.816.816 0 00-.816-.816z'
				fill='#CAE0EC'
			/>
			<path
				d='M152 108v-1h-1v1h1zm0 5h-1v1h1v-1zm0 10l-.124-.992-.876.109V123h1zm0 5h-1v1h1v-1zm0-19h12.184v-2H152v2zm1 4v-5h-2v5h2zm-1 1h7.788v-2H152v2zm7.788 0a.788.788 0 01-.788-.788h2c0-.669-.543-1.212-1.212-1.212v2zm-.788-.788v.726h2v-.726h-2zm0 .726a8.133 8.133 0 01-7.124 8.07l.248 1.984A10.132 10.132 0 00161 113.938h-2zM153 128v-5h-2v5h2zm11-13c0 6.627-5.373 12-12 12v2c7.732 0 14-6.268 14-14h-2zm0-6.184V115h2v-6.184h-2zm.184.184a.184.184 0 01-.184-.184h2a1.816 1.816 0 00-1.816-1.816v2z'
				fill='#00AAE8'
			/>
			<path d='M120 101h28v20c0 7.732-6.268 14-14 14s-14-6.268-14-14v-20z' fill='#E8F3F9' />
			<mask id='a' maskUnits='userSpaceOnUse' x='120' y='101' width='28' height='34'>
				<path d='M120 101h28v20c0 7.732-6.268 14-14 14s-14-6.268-14-14v-20z' fill='#fff' />
			</mask>
			<g mask='url(#a)'>
				<path fill='#F2FAFF' d='M135 101h6v34h-6z' />
			</g>
			<path d='M136 78s-3 1.95-3 5c0 2.95 2.727 4 3 7 .227 2.5-3 6-3 6' stroke='#00AAE8' strokeWidth='2' fill='#FFF' />
		</SvgIcon>
	);
};
